/* eslint-disable jsx-a11y/anchor-is-valid */

import { FC } from 'react';
import { BoxDetailProductType } from '../../types/view/BoxDetailType';
import { SpinButton } from '../SpinButton';

export const ProductGridCell: FC<{
  product: BoxDetailProductType;
  maxQuantity: number;
  onClickProductLink: (variantId: number) => void;
  onChangeQuantity: (variantId: number, quantity: number) => void;
  onloadImg: () => void;
}> = ({ product, maxQuantity, onClickProductLink, onChangeQuantity, onloadImg }) => {
  return (
    <>
      <div key={product.variantId} className="grid-product" style={{ display: 'grid' }}>
        <a style={{ cursor: 'pointer' }} onClick={() => onClickProductLink(product.variantId)}>
          <div style={{ padding: '15px', textAlign: 'center' }}>
            {product.image ? (
              <img
                style={{ maxHeight: '200px', width: 'auto' }}
                className=""
                alt={product.image.altText}
                src={product.image.originalSrc}
                onLoad={onloadImg}
              />
            ) : (
              <img
                style={{ maxHeight: '200px', width: 'auto' }}
                className=""
                alt={product.handle}
                src="//cdn.shopify.com/shopifycloud/shopify/assets/no-image-50-3d8cc48bd078edcd544c8d60f929ed2d8800a3fc52e0f602e84b1767e392bfcd_540x.gif"
                onLoad={onloadImg}
              />
            )}
          </div>
        </a>
        <div style={{ padding: '15px' }}>
          <div className="">
            <div className="price__pricing-group">
              <div style={{ marginBottom: '0.4em' }}>
                <a style={{ cursor: 'pointer' }} onClick={() => onClickProductLink(product.variantId)}>
                  {product.displayName.replace(' - Default Title', '')}
                </a>
              </div>
            </div>
          </div>
          <SpinButton
            value={product.quantity}
            onChange={(quantity) => {
              onChangeQuantity(product.variantId, quantity);
            }}
            min={0}
            max={maxQuantity}
          />
        </div>
      </div>
    </>
  );
};
